import { createContext } from 'react'

/** Recovery pages can be rendered inside Outlet or in place of the root shell. */
export const AppShellContext = createContext(false)
